import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Nav from '../../IDE/components/Header/Nav';
import ExamplesList from '../../IDE/components/ExamplesList';
import { RootPage } from '../../../components/RootPage';

import {
  DashboardTabSwitcher,
  TabKey
} from '../components/DashboardTabSwitcher';

/**
 * Public `/examples` page (no auth required): the AR Examples list. Reuses the dashboard shell so a
 * signed-in user keeps the same tab bar (Sketches/Assets/Shared/AR Examples) and can navigate back to
 * their own sketches; a logged-out visitor sees just the list under the "AR Examples" heading (the
 * per-user tabs would point at "/undefined/..." so they're only rendered when signed in).
 */
const ExamplesView = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const isSignedIn = !!user.username;

  return (
    <RootPage fixedHeight="100%">
      <Nav layout="dashboard" />

      <main className="dashboard-header">
        <div className="dashboard-header__header">
          <h2 className="dashboard-header__header__title">
            {t('ExamplesView.Title', { defaultValue: 'AR Examples' })}
          </h2>
          {isSignedIn && (
            <div className="dashboard-header__nav">
              <DashboardTabSwitcher
                currentTab={TabKey.examples}
                isOwner={false}
                username={user.username}
              />
            </div>
          )}
        </div>

        <div className="dashboard-content">
          <ExamplesList />
        </div>
      </main>
    </RootPage>
  );
};

export default ExamplesView;
